<template>
    <div id="container">
        <template v-if="showExpiredTimeError">
            <span class="notify-window" v-html="$t('kollus_player.notify_message.jwt_expired_time')"></span>
        </template>
        <template v-else>
            <div id="kollus_player_cont">
                <video id="kollus_player" class="video-js vjs-big-play-centered" playsinline></video>
            </div>
            <div v-if="chattingSetView" id="kollus_chatting">
                <kollus-chatting v-if="chattingIframe" :chatroll-info="chattingMediaInfo"></kollus-chatting>
            </div>
        </template>
    </div>
</template>

<script>
import loadJsCss from 'load-js-css';
import KollusChatting from './KollusCatting';

export default {
    name: 'kollus-player-v5',
    props: {
        playerPolicy: {
            type: Object,
            required: true,
        },
        mediaInfo: {
            type: Object,
            required: true,
            default: () => {},
        },
        mediaInfoString: {
            type: String,
            default: '',
        },
        expireTime: {
            type: String,
        },
    },
    data() {
        return {
            playerConfig: this.playerPolicy.player_config.v5,
            chattingKind: this.playerPolicy.chatting_kind,
            fileServiceUrl: this.playerPolicy.file_service_url,
            chattingSetView: true,
            chattingIframe: false,
            chattingMediaInfo: {},
            showExpiredTimeError: false,
        };
    },
    components: {
        'kollus-chatting': KollusChatting,
    },
    beforeMount() {
        loadJsCss.list(this.playerConfig.resources);
        // 전용 플레이어는 mediaInfo가 beforeMount 전에 내려오지 않아서 playerConfig 에 chatting Kind 필드를 추가하였음.
        if (typeof this.chattingKind !== 'undefined') {
            if (this.chattingKind === 'kollus') {
                loadJsCss.list(this.playerConfig.chatting.kollus);
            } else if (this.chattingKind === 'chatroll') {
                loadJsCss.list(this.playerConfig.chatting.chatroll);
            }
        }
    },
    mounted() {
        const timer = setInterval(() => {
            if (typeof window.KollusPlayer !== 'undefined') {
                clearInterval(timer);

                const options = {
                    mediaInfo: this.playerPolicy.use_exclusive_player ? this.playerPolicy.custom_scheme_uri : this.mediaInfo,
                    mediaMode: this.playerPolicy.is_live ? 'live' : 'vod',
                    agentInfo: {
                        // agent 버전확인 URL.
                        versionCheckUrl: this.playerConfig.version_api_url,
                        // agent 실행 API URL
                        executeUrl: this.playerConfig.agent_execute_url,
                        // agent 업데이트/실행 API URL
                        updateUrl: this.playerConfig.agent_execute_url,
                        // agent 설치 URL.
                        installUrl: this.playerConfig.agent_install_url,
                    },
                    jwtExpireTime: this.expireTime,
                    playerLoadingStartTime: Math.floor(new Date().getTime()),
                    eventCallbackFn: (player) => {
                        if (typeof controller !== 'undefined') {
                            controller.register_event_listeners(player);
                        }
                    },
                    chattingCallbackFn: (mediaInfo) => {
                        this.chattingMediaInfo = mediaInfo;
                        if (mediaInfo.chatting && mediaInfo.chatting.data) {
                            switch (mediaInfo.chatting.kind) {
                                case 'kollus':
                                    if (!mediaInfo.chatting.data.anonymous_chat &&
                                        (!mediaInfo.chatting.data.user_id || !mediaInfo.chatting.data.user_name)) {
                                        this.chattingSetView = false;
                                        break;
                                    }
                                    if ((window.location.search && window.location.search.indexOf('nochat') >= 0) || !mediaInfo.chatting.is_visible) {
                                        this.chattingSetView = false;
                                        break;
                                    }
                                    let deviceCheck = this.playerPolicy.device.type ? this.playerPolicy.device.type : 'pc';

                                    if (deviceCheck === 'mobile' || deviceCheck === 'tablet') {
                                        deviceCheck = 'mobile';
                                    } else {
                                        deviceCheck = 'pc';
                                    }

                                    this.kollusChattingInit(mediaInfo, deviceCheck, kollusPlayer);
                                    break;
                                case 'chatroll':
                                    this.chattingSetting(mediaInfo);
                                    break;
                                default:
                                    break;
                            }
                        } else {
                            this.chattingSetView = false;
                        }
                    },
                    // error_callback_fn: (error) => {
                    //     if (error.code === 4085) {
                    //         this.showExpiredTimeError = true;
                    //     }
                    // },
                };

                // KollusHtml5PlayerSDK를 초기화한다.
                const kollusPlayer = new window.KollusPlayer('kollus_player', options);

                // VG-Controller 객체를 생성하고 초기화한다.
                try {
                    // postmessage 라이브러리 동기화를 위해 먼저 객체를 생성함.
                    var controller = new VgControllerServer(kollusPlayer, {
                        player_type: 'v5',
                        target_window: window.parent,
                    });
                } catch (e) {
                    // 발생 가능한 예외
                    // 1. PostMessage 사용 불가
                }

                /**
                 * Agent 초기화 옵션
                 * - isDownload: 다운로드 실행
                 * - downloadFolder: 다운로드 폴더 경로
                 * - playType: 재생 타입 (stream, download, independant)
                 */
                const agentInitializeOption = {
                    isDownload: false,
                    downloadFolder: '',
                    playType: 'stream',
                };

                if (this.playerConfig.mobile_scheme.general.includes('kollus://download_play')) {
                    agentInitializeOption.playType = 'download';
                } else if (this.playerConfig.mobile_scheme.general.includes('kollus://download')) {
                    agentInitializeOption.isDownload = true;
                    agentInitializeOption.downloadFolder = this.playerPolicy.folder_download;
                } else if (this.playerConfig.use_v3_exclusive_player) {
                    agentInitializeOption.playType = 'indenpendant';
                }

                kollusPlayer.initialize(agentInitializeOption);
            }
        });
    },
    methods: {
        kollusChattingInit(options, device, player) {
            const chattingData = options.chatting.data;
            const chattingSkin = options.chatting.custom_skin;
            const videoInfo = options.video_info;
            KOLLUS_CHATTING._KollusChatting.init({
                mode: device,
                videoArea: '#kollus_player_cont',
                chattingArea: '#kollus_chatting',
                videoSize: {
                    width: videoInfo.width,
                    height: videoInfo.height,
                },
                chatting: {
                    admin: options.chatting.is_admin,
                    userId: chattingData.user_id,
                    roomId: chattingData.room_id,
                    rooms: chattingData.rooms || [],
                    nickName: chattingData.user_name,
                    photoUrl: chattingData.photo_url || '',
                    chattingUrl: chattingData.chatting_server,
                    anonymous: !!chattingData.anonymous_chat,
                },
                chattingSkin: {
                    fontUrl: chattingSkin.font_url,
                    fontName: chattingSkin.font_name,
                    fontWeight: chattingSkin.font_weight,
                    fontColor: chattingSkin.font_color,
                    backgroundColor: chattingSkin.background_color,
                    tabFontColor: chattingSkin.tab_font_color,
                    tabBackgroundColor: chattingSkin.tab_background_color,
                },
                player,
            });
        },
        chattingSetting(options) {
            const timer = setInterval(() => {
                if (typeof window.scrollEvent !== 'undefined' && typeof window.scrollView !== 'undefined') {
                    clearInterval(timer);
                    this.chattingSetView = true;
                    this.chattingIframe = true;
                    window.scrollEvent.init({
                        target: 'kollus_chatting',
                        dir: 's ,n ,e ,w',
                        // minHeight: 150,
                        // minWidth: 200,
                        viewCallback: (e) => {
                            window.scrollView.changeView(e);
                        },
                    });

                    window.scrollView.init({
                        targetEl: 'kollus_player_cont',
                        changeEl: {
                            id: 'kollus_chatting',
                            base: 250,
                        },
                        position: options.chatting.position,
                        windowMin: 450,
                        videoSize: options.video_info,
                    });
                } else {
                    this.chattingSetView = false;
                }
            });
        },
    },
};
</script>
<style scoped>
#kollus_player_cont {
    width: 100%;
    height: 100%;
}
.notify-window {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
